import { useContext } from "react";
import { StoreContext } from "../context/web3auth";

export const useStoreContext = () => {
  return useContext(StoreContext);
};
